module.exports = __webpack_public_path__ + "img/img-success-sign.e8dd2465.svg";